import React, {Fragment, useContext} from 'react'
import {AppContext} from '../app/app'
import Config from '../launch/config'

import './css/events-list.css'

const pad = (n) => {
    return n < 10 ? '0' + n : n
}

const EventsList = ({entity}) => {
    const {
        eventLog,
        setModalContentType,
        toggleGameOverOverlay,
        toggleModal,
    } = useContext(AppContext)
    const sorted = eventLog
        .slice()
        .sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1))

    return (
        <Fragment>
            {sorted.map((props, index) => {
                if (!props) {
                    return null
                }

                const {coords, html, timestamp} = props

                const date = new Date(timestamp)
                const hours = pad(date.getHours() % 12 || 12)
                const minutes = pad(date.getMinutes())
                const seconds = pad(date.getSeconds())

                return (
                    <div className="events-list__message" key={index}>
                        <span className="events-list__number">
                            {`${hours}:${minutes}:${seconds}`}
                        </span>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: html,
                            }}
                            onClick={() => {
                                coords &&
                                    Config.scene.cameras.main.pan(
                                        coords.x,
                                        coords.y,
                                        300,
                                        'Linear',
                                        true
                                    )
                                setModalContentType(null)
                                toggleModal()
                                toggleGameOverOverlay(true)
                            }}
                        />
                    </div>
                )
            })}
        </Fragment>
    )
}

export default EventsList
